import { useCallback, useMemo } from 'react'

export function useSingleFileInputProps(
  file: File | null | undefined,
  remoteUrl: string | null | undefined,
  onUpdate: (file: File | null, url: string | null) => void,
) {
  const value = useMemo(() => {
    if (file) {
      return [
        {
          ...file,
          uri: remoteUrl || URL.createObjectURL(file),
          type: file.type,
        },
      ] as any
    }
    if (remoteUrl) {
      return [{ getUrl: remoteUrl, type: 'image/png' }] as any
    }
    return []
  }, [file, remoteUrl])

  const onChange = useCallback(
    (proofs: any[]) => {
      const first = proofs[0]
      if (!first) {
        onUpdate(null, null)
        return
      }
      const url =
        first.uri ??
        (first as { getUrl?: string }).getUrl ??
        (first instanceof Blob ? URL.createObjectURL(first) : null)
      const fileOut = first instanceof File ? first : null
      onUpdate(fileOut, url)
    },
    [onUpdate],
  )

  return { value, onChange }
}
